import type { FC } from 'react';
import {
    Button,
    ButtonGroup,
    Card,
    MatchMedia,
    SkeletonAvatar,
    SkeletonLine,
} from '@george-labs.com/design-system';

import { useGlobalColorVariants } from '@shared/core-ui-layout';

interface Props {
    'data-cy'?: string;
    displaySubTitle?: boolean;
}

const CustomizationButton = () => (
    <Button disabled size={Button.SIZE.SMALL} labelClassName="w-75" className="g-col-12 g-col-md-3">
        <SkeletonLine percentageWidth={100} animated level={5} />
    </Button>
);

export const PersonalizationCardSkeleton: FC<Props> = ({
    'data-cy': dataCy,
    displaySubTitle = true,
}) => {
    const { color } = useGlobalColorVariants();

    return (
        <Card color={color} data-cy={dataCy} className="pl-3 mt-0">
            <MatchMedia max={MatchMedia.TIER.SM}>
                {({ isMatching }) => {
                    const avatarSize = isMatching
                        ? SkeletonAvatar.SIZE.SIZE_64
                        : SkeletonAvatar.SIZE.SIZE_96;

                    const avatar = <SkeletonAvatar size={avatarSize} animated />;

                    return (
                        <div className="g-row align-items-center">
                            {isMatching && <div className="g-col-12 mt-2">{avatar}</div>}
                            <div className="g-col">
                                <SkeletonLine
                                    className="mt-3"
                                    percentageWidth={60}
                                    animated
                                    level={2}
                                />
                                {displaySubTitle && (
                                    <SkeletonLine level={5} animated percentageWidth={30} />
                                )}
                                <ButtonGroup className="g-row pr-5">
                                    <CustomizationButton />
                                    <CustomizationButton />
                                    <CustomizationButton />
                                </ButtonGroup>
                            </div>
                            {!isMatching && <div className="g-col-auto mr-3">{avatar}</div>}
                        </div>
                    );
                }}
            </MatchMedia>
        </Card>
    );
};
